export default "__VITE_ASSET__DpT5jFi3__"